import { useTranslation } from "react-i18next";

const WorkData = ({ title, image, date, description, link }) => {
  const { t } = useTranslation();
  return (
    <div className="w-4/5 py-4 px-8 bg-slate-300 shadow-lg rounded-lg">
      <div className="flex justify-center md:justify-start -mt-16">
        <img alt="bro" className="w-20 h-20 object-cover rounded-full" src={image} />
      </div>
      <div>
        <h2 className="text-gray-800 text-3xl font-semibold">{title}</h2>
        <p className="text-gray-700 text-right">{date}</p>
        <p className="mt-2 text-gray-600">{description}</p>
      </div>
      <div className="flex justify-end mt-4">
        <a href={link} target="_blank" rel="noreferrer" className="text-xl font-medium text-purple-500">
          {t("visit_website")}
        </a>
      </div>
    </div>
  );
};

export default WorkData;
